import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { app2020 } from '../../json/app2020';
import { app2021 } from '../../json/app2021';
import Cpapp from './Cpapp';

const CpappAnteriores = () => {
    
    const  { ciclo }  = useParams();
        
    const [ datosApp, setdatosApp ] = useState ( [] );

        const selCpapp = async () => {     
            switch (ciclo) {
                case '2020':
                setdatosApp (app2020)
                break
                case '2021':
                setdatosApp (app2021)
                break
            }
        }

        useEffect(() => {
            selCpapp();
            window.scrollTo(0, 0);

        },     [ ciclo ]);

    return(        
        <>
            <>
                <br />
                <Cpapp ciclo={ciclo} asociacion={ datosApp } />
            </>
        </>
    )
}

export default CpappAnteriores